var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ah-receipt-number"},[_c('span',{staticClass:"words"},[_vm._v(_vm._s(_vm.formatedNumber.words))]),_c('span',{staticClass:"numbers"},[_vm._v(_vm._s(_vm.formatedNumber.numbers))])])}
var staticRenderFns = []

export { render, staticRenderFns }